import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import AlertDialogSlide from "../components/Dialog";
import { image_ip } from "../services/constants";

import { Container, Grid, Paper } from "@material-ui/core";

import { useNavigate } from "react-router-dom";
import SpecCard from "../components/cards/SpecCard";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme";

import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { addProduct } from "../services/actions";

import { toast } from "react-toastify";

function Item(props) {
  const location = useLocation();
  const nav = useNavigate();
  console.log(location);
  const product = location.state.product;

  console.log("product:-", product.details);
  const handleCart = props.handleCart;
  const [quantity, setQuantity] = useState(1);
  const handleCartSpec = props.handleCartSpec;
  // const nav = useNavigate()
  const dispach = useDispatch();

  const [success, setSuccess] = useState(false);
  const dialogue_data = {
    yes: "Clear",
    no: "Cancel",
    primary: "Clear Cart",
    secondary: "Products from other stores are in the cart clear the cart?",
  };
  const checkStore = useCallback(
    (item) => {
      const previousStore = localStorage.getItem("store_id");
      if (previousStore !== item.store_id) {
        setSuccess(true);
      } else {
        addProductToCart(item);
      }
    },
    [props]
  );

  const addToCart = (product, item) => {
    var temp = product;
    temp.specifications = item.spec;
    dispach(addProduct(temp));
    toast.success("Product added !", {
      position: toast.POSITION.TOP_RIGHT,
    });
    handleCart(temp);
    // handleCartSpec(product,item)
  };

  const addProductToCart = (product) => {
    console.log("here to implement more shit for product");
    var temp = new Object(product);
    temp.quantity = quantity;

    dispach(addProduct(temp));
    toast.success("Product added !", {
      position: toast.POSITION.TOP_RIGHT,
    });
    handleCart(temp);
    nav(-1);
  };

  const goToCart = (e) => {
    e.preventDefault();
    nav("/basket");
  };
  const addQuan = function () {
    var temp = quantity + 1;
    setQuantity(temp);
  };
  const minuQuan = function () {
    if (quantity == 0) {
      return;
    }
    var temp = quantity - 1;
    setQuantity(temp);
  };
  const style = {
    margin: "auto",
    marginTop: "10px",
  };

  if (product.specifications.length == 0) {
    return (
      <div
        style={{
          backgroundColor: "white",
          width: "100vw", // Full width of the viewport
          height: "100vh",
        }}
      >
        <Card style={style}>
          <ThemeProvider theme={theme}>
            <CardMedia
              component="img"
              height="270"
              image={`${image_ip}${product.image_url[0]}`}
              // image='zmall.png'
              alt="unable to load image"
              onError={({ currentTarget }) => {
                currentTarget.onError = null; // prevents looping
                currentTarget.src = "/zmall.png";
              }}
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                style={{ textAlign: "left", fontSize: "1.2rem" }}
              >
                {product.name}
              </Typography>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                style={{ textAlign: "left", fontSize: "0.7rem" }}
              >
                {product.details}
              </Typography>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  style={{
                    fonstSize: "0.8rem",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "bold",
                  }}
                >
                  Price: {product.price}
                </Typography>
                <CardActions>
                  <Button
                    onClick={() => {
                      minuQuan();
                    }}
                  >
                    <RemoveIcon
                      size="small"
                      style={{ width: "15px" }}
                      color="neutral"
                    >
                      -
                    </RemoveIcon>
                  </Button>
                  <div style={{ fonstSize: "0.8rem" }}>{quantity}</div>
                  <Button
                    onClick={() => {
                      addQuan();
                    }}
                  >
                    <AddIcon
                      size="small"
                      style={{ width: "15px" }}
                      color="neutral"
                    >
                      +
                    </AddIcon>
                  </Button>
                </CardActions>
              </div>

              <Typography
                variant="body2"
                color="text.secondary"
                style={{ fonstSize: "0.8rem" }}
              >
                No specification found
              </Typography>

              <CardActions style={{ justifyContent: "space-between" }}>
                <Button
                  size="small"
                  onClick={() => {
                    checkStore(product);
                  }}
                  color="neutral"
                  variant="contained"
                >
                  Add to Cart
                </Button>
                {/* <Button size="small" onClick={() => { addProductToCart(product) }} color='neutral' variant="contained">Add to Cart</Button> */}

                <Button
                  size="small"
                  onClick={(e) => {
                    goToCart(e);
                  }}
                  color="neutral"
                  variant="contained"
                  endIcon={<ArrowForwardIcon />} // Add the arrow here
                >
                  Go to Cart
                </Button>
              </CardActions>
            </CardContent>
          </ThemeProvider>
        </Card>
        <AlertDialogSlide
          open={success}
          data={dialogue_data}
          confirm={() => {
            addProductToCart(product);
            setSuccess(false);
          }}
          not={() => {
            setSuccess(false);
          }}
        />
      </div>
    );
  } else {
    console.log("asdfg", product.specifications);
    return (
      <div>
        <Card style={style}>
          <CardMedia
            component="img"
            height="270"
            image={`${image_ip}${product.image_url[0]}`}
            // image='zmall.png'
            onError={({ currentTarget }) => {
              // console.log('erroringgggggggggggggg',currentTarget)
              currentTarget.onError = null; // prevents looping
              currentTarget.src = "/zmall.png";
            }}
            alt="unable to load image"
          />
          <SpecCard
            spec={product.specifications}
            product={product}
            addToCart={addToCart}
          />
        </Card>
      </div>
    );
  }
}

export default Item;
